export default "__VITE_ASSET__C5idT3mq__"